import { NgModule } from '@angular/core';
import {
  ButtonModule,
  ImageModule,
  LinkModule
} from '@com-delta-idp/mnx-ui-kit';
import { MicroMomentsComponent as AuraMicroMoment } from '@com-delta-omnichannel/aura';
import { MicroMomentsComponent } from './micro-moments.component';

@NgModule({
  declarations: [MicroMomentsComponent],
  imports: [ImageModule, ButtonModule, LinkModule, AuraMicroMoment],
  exports: [MicroMomentsComponent]
})
export class MicroMomentsModule {}
